import { Phone, Mail, Clock, MapPin } from "lucide-react";
import { BUSINESS } from "@/lib/constants";

export default function ContactCard() {
    return (
        <div className="a1-card flex flex-col gap-5" data-testid="contact-card">
            <div className="flex items-start gap-4">
                <div className="a1-icon-wrap">
                    <Phone size={20} strokeWidth={2.2} />
                </div>
                <div>
                    <p
                        className="text-[11px] font-bold uppercase tracking-[0.18em] mb-1"
                        style={{ color: "var(--color-text-dim)" }}
                    >
                        Phone
                    </p>
                    <a
                        href={`tel:${BUSINESS.phoneTel}`}
                        className="serif text-2xl md:text-[28px] font-bold no-underline"
                        style={{ color: "var(--color-accent)" }}
                    >
                        {BUSINESS.phone}
                    </a>
                </div>
            </div>
            <hr className="a1-divider" />
            <div className="flex items-start gap-4">
                <div className="a1-icon-wrap">
                    <Mail size={20} strokeWidth={2.2} />
                </div>
                <div>
                    <p
                        className="text-[11px] font-bold uppercase tracking-[0.18em] mb-1"
                        style={{ color: "var(--color-text-dim)" }}
                    >
                        Email
                    </p>
                    <a
                        href={`mailto:${BUSINESS.email}`}
                        className="text-base font-semibold no-underline"
                        style={{ color: "var(--color-text)" }}
                    >
                        {BUSINESS.email}
                    </a>
                </div>
            </div>
            <hr className="a1-divider" />
            <div className="flex items-start gap-4">
                <div className="a1-icon-wrap">
                    <Clock size={20} strokeWidth={2.2} />
                </div>
                <div>
                    <p
                        className="text-[11px] font-bold uppercase tracking-[0.18em] mb-1"
                        style={{ color: "var(--color-text-dim)" }}
                    >
                        Hours
                    </p>
                    <p className="text-base font-semibold" style={{ color: "var(--color-text)" }}>
                        {BUSINESS.hours}
                    </p>
                </div>
            </div>
            <hr className="a1-divider" />
            <div className="flex items-start gap-4">
                <div className="a1-icon-wrap">
                    <MapPin size={20} strokeWidth={2.2} />
                </div>
                <div>
                    <p
                        className="text-[11px] font-bold uppercase tracking-[0.18em] mb-1"
                        style={{ color: "var(--color-text-dim)" }}
                    >
                        Service Area
                    </p>
                    <p className="text-base" style={{ color: "var(--color-text-muted)" }}>
                        <strong className="a1-accent">{BUSINESS.primaryCity}</strong> (home base) —
                        also serving {BUSINESS.secondaryCities.join(", ")}.
                    </p>
                </div>
            </div>
        </div>
    );
}
